import PropTypes from 'prop-types';
import RawHtml from '../../Utilities/RawHtml';

const Paragraph = ({ html, footnoteIndex }) => (
  <div className="text-base">
    <RawHtml
      html={html}
      footnoteIndex={footnoteIndex}
      className="rich-content--article-body"
    />
  </div>
);

Paragraph.propTypes = {
  html: PropTypes.string.isRequired,
  footnoteIndex: PropTypes.object,
};

Paragraph.defaultProps = {
  footnoteIndex: {},
};

export default Paragraph;